// extracted by mini-css-extract-plugin
export default {"LinkButton":"_LinkButton--M9hhi","ExternalLink":"_ExternalLink--YL7JH"};